/* --------------------------------------------------------------------------------------
   appGallery.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/
import { localVar } from "../constants/storage.const"
import { getLocalVar, setLocalVar, clearLocalVar} from "./browserStorage"
import { getUrlSearchParamsAsObj } from "./util"

const urlSearchParamsObj = getUrlSearchParamsAsObj()
const calledByShell = !!urlSearchParamsObj.serial
const storeAppGallerySettings = () => setLocalVar(localVar.appGallerySettings, JSON.stringify(urlSearchParamsObj))
const getStoredAppGallerySettings = () => JSON.parse(getLocalVar(localVar.appGallerySettings))

export const getAppGallerySettings = () => {
    calledByShell && storeAppGallerySettings()
    return getStoredAppGallerySettings()
} 

export const clearAppGallerySettings = () => clearLocalVar(localVar.appGallerySettings);
